import * as Yup from 'yup';

export const validationSchema = Yup.object({
  code_method: Yup.string().required('Esta opção é obrigatória'),
  language: Yup.string().required('Esta opção é obrigatória'),
});
